import { type ChannelDetail, getChannelDetailData } from 'models';
import { useQuery } from 'query';
import { getChannelDetail } from '../services';
import { getChannelDetailQueryKey } from './keys';

type P = { channelId: string };

export const useChannelDetailQuery = ({ channelId }: P) =>
  useQuery<ChannelDetail>({
    async queryFn() {
      const { data } = await getChannelDetail(channelId);

      return getChannelDetailData(data);
    },
    queryKey: getChannelDetailQueryKey({ channelId }),
  });
